(function (window) {
  'use strict';

  if (window.GhostModalFocus) return;

  function getFocusable(container) {
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (node) {
        return !node.hidden && node.getAttribute('aria-hidden') !== 'true';
      });
  }

  var lastFocus = null;

  window.GhostModalFocus = {
    rememberFocus: function () {
      lastFocus = document.activeElement;
    },

    restoreFocus: function () {
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
      lastFocus = null;
    },

    focusInitial: function (panel, closeSelector) {
      if (!panel) return;

      var closeButton = closeSelector ? panel.querySelector(closeSelector) : null;
      var target = closeButton || getFocusable(panel)[0];

      if (target) target.focus();
    },

    trapTab: function (event, panel) {
      if (event.key !== 'Tab' || !panel) return false;

      var focusables = getFocusable(panel);
      if (!focusables.length) return false;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
        return true;
      }

      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
        return true;
      }

      return false;
    }
  };
})(window);
